import { Model } from '@/clients/http'

import { AttributeValueHttpParams, AttributeValueResponses } from '@/types'

export class AttributeValueModel extends Model {
  public static readonly correlations = {
    GET_LIST: 'ATTRIBUTE_VALUE_GET_LIST',
    CREATE: 'ATTRIBUTE_VALUE_CREATE',
    UPDATE: 'ATTRIBUTE_VALUE_UPDATE',
    DELETE: 'ATTRIBUTE_VALUE_DELETE',
  }

  public static readonly endpoints = {
    getList: (props?: AttributeValueHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute-value',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: AttributeValueHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute-value',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: AttributeValueHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute-value/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: AttributeValueHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/attribute-value/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getList = async (params?: AttributeValueHttpParams.GetList) => {
    return this.createHttpRequest<AttributeValueResponses.GetList>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(params),
        useBearerToken: true,
      },
    })
  }

  public static readonly create = async (params: AttributeValueHttpParams.Create) => {
    return this.createHttpRequest<AttributeValueResponses.Create>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(params),
        body: params.body,
        useBearerToken: true,
      },
    })
  }

  public static readonly update = async (params: AttributeValueHttpParams.Update) => {
    return this.createHttpRequest<AttributeValueResponses.Update>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(params),
        body: params.body,
        useBearerToken: true,
      },
    })
  }

  public static readonly delete = async (params: AttributeValueHttpParams.Delete) => {
    return this.createHttpRequest<AttributeValueResponses.Delete>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(params),
        useBearerToken: true,
      },
    })
  }
}
